import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { LicenseHostMap } from '@portal-core/license-host-maps/models/license-host-map.model';

@CollectionStateSelectors({
  stateType: LicenseHostMapsState
})
@State<LicenseHostMapsState>({
  name: LicenseHostMapsState.source
})
@Service({ autoProvided: false })
export class LicenseHostMapsState extends CollectionStateBase {
  static override source: string = 'LicenseHostMaps';
  getSource(): string {
    return LicenseHostMapsState.source;
  }
}

@Service()
export class LicenseHostMapsDataService extends CollectionDataServiceBase<LicenseHostMap> {
  protected readonly stateType = LicenseHostMapsState;
}
